import { Area, PrstTxWarp } from '../../../type/common.interface';
import { getFuncsOval } from '../../utils/get-funcs-oval';

export function textCanDown(prstTxWarp: PrstTxWarp, area: Area) {
    const bottomLine = (x: number) => {
        const k = 0;
        const h = area.width / 2;
        const a = area.width / 2;
        const b = area.height / 3;

        return getFuncsOval(x, k, h, a, b)[1]();
    };

    const topLine = (x: number) => {
        const k = area.height * 2 / 3;
        const h = area.width / 2;
        const a = area.width / 2;
        const b = area.height / 3;

        return getFuncsOval(x, k, h, a, b)[1]();
    };

    return [
        bottomLine,
        topLine,
    ];
}
